import {Component, HostListener, Input, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalRightService} from 'app/services/modal-right/modal-right.service';
import {BehaviorSubject} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Component({
    selector: 'app-document-appercue',
    templateUrl: './document-appercue.component.html',
    styleUrls: ['./document-appercue.component.scss']
})
export class DocumentAppercueComponent implements OnInit {

    showTotals = true;
    showContactInfo = true;
    showDescription = false;
    noteText = '';

    isCustomizerOpen = false;
    customizerWidth = '0%';
    sidebarOpened = false;


    constructor(private customizerService: ModalRightService) {}

    ngOnInit(): void {
        this.customizerService.isCustomizerOpen$
            .pipe(debounceTime(100))
            .subscribe(state => {
            console.log('Customizer open state:', state);
            this.isCustomizerOpen = state;
            this.customizerWidth = state ? '58%' : '0%';
        });

        this.customizerService.sidebarData$.subscribe(data => {
            console.log('Sidebar data received:', data);
            this.showTotals = data.showTotals;
            this.showContactInfo = data.showContactInfo;
            this.showDescription = data.showDescription;
            this.noteText = data.noteText;
        });
    }

    @HostListener('document:click', ['$event'])
    onOutsideClick(event: MouseEvent) {
        if (!this.sidebarOpened) return; // don't check before sidebar is open

        const sidebar = document.querySelector('.customizer-content');
        if (sidebar && !sidebar.contains(event.target as Node)) {
            this.customizerService.close();
            this.sidebarOpened = false;
        }
    }


    toggleCustomizer() {
        this.customizerService.close();
    }



}
